export const defaultState = {
  myExitRequests: [],
  rehabilitations: [],
  exitTypes: [],
  employeeExitRequest: null,
  exitRequestAttachments:[]
};
